import type { AssigneeModel } from '@bliks-io/contracts';
import {
  AssigneeCard,
  toAssigneeCardRecord,
  type AssigneeCardEntity,
  type AssigneeCardVariants
} from '@bliks-io/ui';

/**
 * The informative line each card carries in a step preview: a person's Stelle,
 * a system's category, a team's shared mailbox, a contact's type.
 */
const STEP_PREVIEW_VARIANTS: AssigneeCardVariants = {
  User: 'with-role',
  System: 'with-category',
  OrgFunction: 'with-email',
  ExternalContact: 'with-type'
};

interface EntityHeaderProps {
  entity: AssigneeCardEntity;
  entityType?: AssigneeModel;
  className?: string;
}

/**
 * The assignee chip a step preview draws above its own content.
 *
 * The dispatch from a model to a card lives in `@bliks-io/ui`'s `AssigneeCard`;
 * this is the step-preview surface's variant policy and nothing more.
 */
export function EntityHeader({
  entity,
  entityType = 'User',
  className = 'p-0'
}: EntityHeaderProps) {
  const record = toAssigneeCardRecord(entityType, entity);
  if (!record) return null;

  return <AssigneeCard record={record} variants={STEP_PREVIEW_VARIANTS} className={className} />;
}
